$(".new-header-drawer-close").click(function(){
  $(this).parents(".menu-drawer-container").find(".header__icon--menu").trigger("click");
})
$(".new-header-drawer--open").click(function(e){
  e.preventDefault();
  $(this).toggleClass("new-header-drawer--active");
  $(this).next('ul').slideToggle(300);
})
$(document).on("change", ".new-card-options-input", function(){
  $(this).parents(".card-wrapper").find(".new-card-img--main").attr("src", $(this).val());
})
$(".new-pdp-acc-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".new-pdp-acc-content").slideToggle(300);
})


// ====== CONFIG ======
// Large images (main gallery)
const images = document.querySelectorAll(".product__media-wrapper > media-gallery .product__media-item");
// Corresponding thumbnails
const thumbnails = document.querySelectorAll(".new-pdp-media-thumb");


// ====== REMOVE ACTIVE FROM ALL THUMBNAILS ======
function clearActive() {
  thumbnails.forEach(t => t.classList.remove("active"));
}


// ====== SETUP OBSERVER ======
const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = [...images].indexOf(entry.target);

        clearActive();
        thumbnails[index]?.classList.add("active");
      }
    });
  },
  {
    root: null,        // viewport
    threshold: 0.6     // % of image visible before triggering
  }
);


// ====== OBSERVE EACH IMAGE ======
images.forEach(img => observer.observe(img));


// Optional: thumbnail click scroll behavior
thumbnails.forEach((thumb, i) => {
  thumb.addEventListener("click", () => {
    images[i].scrollIntoView({ behavior: "smooth", block: "center" });
  });
});


class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.limit = parseInt(this.getAttribute('limit')) || 6;
    this.key = "recently_viewed_products";
    this.handles = [];
    this.wrapper = this.querySelector(".new-related-swiper");
  }

  connectedCallback() {
    this.loadHandles();
    this.renderProducts();
  }

  loadHandles() {
    try {
      const stored = localStorage.getItem(this.key);
      this.handles = stored ? JSON.parse(stored).slice(0, this.limit) : [];
    } catch(e) {
      console.error("Error parsing recently viewed localStorage", e);
      this.handles = [];
    }
  }

  saveHandles() {
    localStorage.setItem(this.key, JSON.stringify(this.handles.slice(0, this.limit)));
  }

  addProduct(handle) {
    // prevent duplicates
    this.handles = this.handles.filter(h => h !== handle);

    // insert at front
    this.handles.unshift(handle);

    // limit
    this.handles = this.handles.slice(0, this.limit);

    this.saveHandles();
  }

  async renderProducts() {
    if (!this.handles.length) {
      this.innerHTML = `<p>No recently viewed products.</p>`;
      return;
    }

    // Grab HTML for all handles

    for (let handle of this.handles) {
      const url = `${window.location.origin}/products/${handle}?view=recent`;

      try {
        const res = await fetch(url);
        const html = await res.text();

        const temp = document.createElement("div");
        temp.innerHTML = html;

        const card = temp.querySelector(`.new-related-slide`);
        if (card) this.wrapper.appendChild(card);
      } catch (e) {
        console.error(`Failed to load product: ${handle}`, e);
      }
    }
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);